interface TurnScrollMetrics {
  currentScrollTop: number;
  maxScrollTop: number;
  viewportHeight: number;
  replyTop: number;
  replyBottom: number;
  contextTop?: number;
  padding?: number;
}

function clamp(value: number, minimum: number, maximum: number) {
  return Math.min(Math.max(value, minimum), maximum);
}

export function turnScrollTop({
  currentScrollTop,
  maxScrollTop,
  viewportHeight,
  replyTop,
  replyBottom,
  contextTop = replyTop,
  padding = 8,
}: TurnScrollMetrics) {
  const availableHeight = Math.max(0, viewportHeight - padding * 2);
  const turnHeight = replyBottom - contextTop;

  if (turnHeight > availableHeight) {
    return clamp(replyTop - padding, 0, maxScrollTop);
  }

  const minimum = replyBottom - viewportHeight + padding;
  const maximum = contextTop - padding;
  return clamp(
    clamp(currentScrollTop, minimum, maximum),
    0,
    maxScrollTop,
  );
}
